/* Shopify renders the translated content before JavaScript. Language changes
 * use its localization form and carry the existing Binom visit to the new URL. */
(function () {
  'use strict';
  var form = document.getElementById('OdorCrushLanguageForm');
  if (!form) return;
  var select = form.querySelector('[name="language_code"]');
  var returnTo = form.querySelector('[name="return_to"]');
  var suggestion = document.querySelector('[data-oc-language-suggestion]');
  var current = document.documentElement.lang;
  var key = 'odor_crush_language';
  var dismissedKey = 'odor_crush_language_suggestion_dismissed';
  var pending = false;
  function storage(method, name, value) {
    try { return window.localStorage[method](name, value); } catch (error) { return null; }
  }
  function available(code) {
    return Array.prototype.some.call(select.options, function (option) { return option.value === code; });
  }
  function submit() {
    var url = new URL(window.location.href);
    url.searchParams.delete('lang');
    var tracking = window.OdorCrushTracking;
    var id = tracking && tracking.getClickId();
    if (typeof id === 'string' && /^[A-Za-z0-9_-]{1,200}$/.test(id)) url.searchParams.set('bcid', id);
    returnTo.value = url.pathname + url.search + url.hash;
    storage('setItem', key, select.value);
    form.submit();
  }
  function change(code) {
    if (pending || !available(code) || code === current) return;
    select.value = code;
    pending = true;
    if (suggestion) suggestion.hidden = true;
    form.setAttribute('aria-busy', 'true');
    var tracking = window.OdorCrushTracking;
    if (!tracking || tracking.status !== 'loading') { submit(); return; }
    var done = false;
    var observer;
    var timer;
    function complete() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (observer) observer.disconnect();
      submit();
    }
    observer = new MutationObserver(function () {
      if (tracking.status !== 'loading') complete();
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-binom-status'] });
    timer = setTimeout(complete, 4000);
    if (tracking.status !== 'loading') complete();
  }
  select.addEventListener('change', function () { change(select.value); });
  form.addEventListener('submit', function (event) { event.preventDefault(); change(select.value); });
  if (suggestion) {
    suggestion.querySelector('[data-oc-language-spanish]').addEventListener('click', function () { change('es'); });
    suggestion.querySelector('[data-oc-language-dismiss]').addEventListener('click', function () {
      suggestion.hidden = true;
      storage('setItem', dismissedKey, '1');
    });
  }
  // Keep old explicit ad-language URLs working. Browser language only suggests
  // a choice; it never redirects or changes an indexable document's content.
  var requested = new URLSearchParams(window.location.search).get('lang');
  if (/^(en|es)$/.test(requested) && available(requested) && requested !== current) {
    change(requested);
    return;
  }
  var browser = (navigator.languages && navigator.languages[0]) || navigator.language || 'en';
  if (suggestion && current === 'en' && available('es') && /^es(?:-|$)/i.test(browser)
      && !storage('getItem', key) && !storage('getItem', dismissedKey)) suggestion.hidden = false;
})();
